"use client"

import React from "react";
import { useTranslations } from "next-intl";
import { useSession } from "next-auth/react";
import { Flex } from "antd";
import {
    Card,
} from "@/theme/ui";
import { SupportCountry } from "@/components/reports/supportCountry";
import { PurchasedConnections } from "@/components/reports/purchasedConnections";
import { UserCountries } from "@/components/reports/userCountries";


export const ReportsComponent = () => {
    const t = useTranslations('reports');
    const { data: session } = useSession();
    return (
        <>
            <Card
                title={t('title')}
                className={'roles'}
            >
                {session?.user?.role === 'SuperAdmin' &&
                    <>
                        <Flex
                            gap={20}
                            style={{
                                marginBottom: '20px'
                            }}
                            className={'custom_support_flex'}
                        >
                            <SupportCountry />
                            <PurchasedConnections />
                        </Flex>
                        <UserCountries />
                    </>
                }
                {session?.user?.role !== 'SuperAdmin' && session?.user?.permissions?.includes('reports-country-manager') &&
                    <Flex
                        gap={20}
                        style={{
                            marginBottom: '20px'
                        }}
                        className={'custom_support_flex'}
                    >
                        <UserCountries />
                        <PurchasedConnections />
                    </Flex>
                }
            </Card>
        </>
    );
}